import { useEffect } from "react";

export default function TermlyCMP({ websiteUUID, autoBlock, masterConsentsOrigin }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://app.termly.io/resource-blocker/${websiteUUID}?autoBlock=${autoBlock}&masterConsentsOrigin=${masterConsentsOrigin}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
        if (document.head.contains(script)) {
            document.head.removeChild(script);
        }
    };
  }, [websiteUUID, autoBlock, masterConsentsOrigin]);

  return null;
}